'use strict';

frontendApp.controller('OrganizationCtrl', ['$scope', '$rootScope', 'OrganizationService', 'NavigationService', function($scope, $rootScope, OrganizationService, NavigationService) {
    NavigationService.setActiveTab('organizations');
    $rootScope.$broadcast('clearCurrentSelected');
    $scope.organizations = OrganizationService.findAll();
}]);
